import type { ComponentType } from "react";
import type { SvgIconProps } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import type { SidebarItemKey } from "../../config/sidebarConfig";

/** A key of the theme's `palette.colors`, used for the card's icon and its tinted circle. */
type CardColor = "teal" | "purple" | "orange" | "pink" | "blue" | "green";

type ExampleCardStyle = {
  icon: ComponentType<SvgIconProps>;
  color: CardColor;
  /** What the question's page holds, shown under the question */
  hint: string;
};

/** How an example question looks in the empty chat, by the sidebar page it's about. */
export const EXAMPLE_CARD_STYLES: Record<SidebarItemKey, ExampleCardStyle> = {
  home: { icon: HomeOutlinedIcon, color: "teal", hint: "From your Home overview." },
  create: { icon: AddCircleOutlineIcon, color: "green", hint: "Write and send a new Notice." },
  notices: { icon: NotificationsNoneOutlinedIcon, color: "pink", hint: "See and manage your Notices." },
  calendar: { icon: CalendarMonthOutlinedIcon, color: "purple", hint: "Find and manage Events." },
  users: { icon: PeopleOutlineIcon, color: "blue", hint: "The parents in your Organization." },
  circles: { icon: GroupsOutlinedIcon, color: "orange", hint: "Groups that Notices go to." },
  team: { icon: AdminPanelSettingsOutlinedIcon, color: "orange", hint: "Add and manage staff members." },
  library: { icon: MenuBookOutlinedIcon, color: "purple", hint: "Worksheets and resources." },
  drive: { icon: FolderOutlinedIcon, color: "blue", hint: "Your saved files." },
  nova: { icon: AutoAwesomeOutlinedIcon, color: "teal", hint: "Tell Nova what's happening." },
  helpCenter: { icon: HelpOutlineIcon, color: "pink", hint: "Step-by-step guides." },
  adCenter: { icon: ShoppingCartOutlinedIcon, color: "green", hint: "Your adverts." },
  account: { icon: PersonOutlineIcon, color: "teal", hint: "Your details and settings." },
};

export const STARTER_ACTIONS = [
  { id: "create.notice", question: "Create a notice", hint: "Share an update with your community." },
  { id: "users.open", question: "View users", hint: "See the users in your organization." },
  { id: "create.notice", question: "Create a poll", hint: "Ask a question and collect votes." },
  { id: "helpCenter.courses", question: "Go to courses", hint: "Learn how to use Noticeboard." },
];
